<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4 style="max-width: 500px; max-height: 600px">
        <v-card class="elevation-12 card" style="border: 10px solid #05523e">
          <v-stepper v-model="step">
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-icon
                  size="30"
                  @click="$router.go(-1)"
                  style="
                    position: absolute;
                    left: 20px;
                    top: 20px;
                    color: #05523e;
                  "
                  >mdi-arrow-left-thick</v-icon
                >
                <div style="padding: 60px">
                  <div
                    style="
                      font-size: 40px;
                      font-weight: bold;
                      color: #05523e;
                      margin: 10px auto;
                    "
                  >
                    Find your Id
                  </div>
                  <div
                    style="
                      color: #929292;
                      font-size: 18px;
                      font-weight: 500;
                      margin-bottom: 20px;
                    "
                  >
                    Enter the email you entered when you signed up.
                  </div>
                  <input
                    class="email"
                    v-model="email"
                    @input="emailValidation"
                    v-on:keyup.enter="sendEmail"
                  />
                  <p style="color: red; margin: 3px 0 0 7px; font-size: 13px">
                    {{ this.emailMessage }}
                  </p>
                  <v-btn
                    fontColor
                    class="white--text elevation-0 buttons"
                    color="#05523E"
                    style="
                      width: 100%;
                      height: 50px;
                      font-size: 18px;
                      font-weight: bold;
                      margin: 20px auto;
                    "
                    @click="sendEmail"
                  >
                    SEND
                  </v-btn>
                </div>
              </v-stepper-content>

              <v-stepper-content step="2">
                <v-icon
                  size="30"
                  @click="step = 1"
                  style="
                    position: absolute;
                    left: 20px;
                    top: 20px;
                    color: #05523e;
                  "
                  >mdi-arrow-left-thick</v-icon
                >
                <div style="padding: 60px">
                  <div
                    style="font-size: 40px; font-weight: bold; color: #05523e"
                  >
                    <div style="height: 48px">Enter</div>
                    <div>Verification code</div>
                  </div>
                  <div
                    style="
                      color: #929292;
                      font-size: 18px;
                      font-weight: 500;
                      margin-bottom: 20px;
                    "
                  >
                    A verification code has been to your email. please enter it
                    to verify your email.
                  </div>
                  <input class="email" v-model="code" @input="codeValidation" />
                  <p style="color: red; margin: 3px 0 0 7px; font-size: 13px">
                    {{ this.codeMessage }}
                  </p>
                  <v-btn
                    fontColor
                    class="white--text elevation-0 buttons"
                    color="#05523E"
                    style="
                      width: 100%;
                      height: 50px;
                      font-size: 18px;
                      font-weight: bold;
                      margin: 20px auto;
                    "
                    @click="verifyCode"
                  >
                    SEND
                  </v-btn>
                </div>
              </v-stepper-content>

              <v-stepper-content step="3">
                <v-icon
                  size="30"
                  @click="step = 2"
                  style="
                    position: absolute;
                    left: 20px;
                    top: 20px;
                    color: #05523e;
                  "
                  >mdi-arrow-left-thick</v-icon
                >
                <div style="padding: 60px">
                  <div
                    style="font-size: 40px; font-weight: bold; color: #05523e"
                  >
                    Check your ID
                  </div>
                  <div
                    style="
                      color: #929292;
                      font-size: 18px;
                      font-weight: 500;
                      margin-bottom: 20px;
                    "
                  >
                    The ID you signed up for is as follows.
                  </div>
                  <div
                    style="
                      text-align: center;
                      color: #05523e;
                      margin: 10px auto;
                      font-size: 22px;
                      font-weight: bold;
                    "
                  >
                    {{ this.userId }}
                  </div>
                  <v-btn
                    class="elevation-0 buttons"
                    color="#ffffff"
                    style="
                      border: 2px solid #05523e;
                      width: 100%;
                      height: 50px;
                      font-size: 18px;
                      font-weight: bold;
                      margin: 20px auto;
                      color: #05523e;
                    "
                    @click="logIn"
                  >
                    LOG IN
                  </v-btn>
                </div>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { runGqlMutation, runGqlQuery } from "@/graphql/gqlUtil.js";
import { CREATEEMAILCODE, CHECKEMAILCODE } from "@/graphql/AccountMutations.js";

export default {
  data() {
    return {
      step: 1,
      email: "",
      emailMessage: "",
      code: "",
      codeMessage: "",
      realCode: "",
      userId: "",
    };
  },
  methods: {
    async emailValidation() {
      if (
        await !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.email)
      ) {
        this.emailMessage = "E-mail must be valid";
      } else {
        this.emailMessage = "";
      }
    },
    async sendEmail() {
      if (this.emailMessage !== "" || this.email.length === 0) {
        this.emailMessage = "required";
        return;
      }
      const emailResult = await runGqlMutation(CREATEEMAILCODE, {
        Email: this.email,
      });
      if (emailResult.message === undefined) {
        this.realCode = emailResult.createEmailCode.Code;
        this.userId = emailResult.createEmailCode.Admin.ID;
        this.step = 2;
      } else {
        await this.$store.commit("common/snackErrOn", {
          text: emailResult.message,
        });
      }
    },
    async codeValidation() {
      if (this.code.length !== 6) {
        this.codeMessage = "Please enter 6 characters";
      } else {
        this.codeMessage = "";
      }
    },
    async verifyCode() {
      const checkEmail = await runGqlQuery(CHECKEMAILCODE, {
        Code: this.code,
        Email: this.email,
      });
      console.log(checkEmail);
      if (checkEmail.message === undefined) {
        // check 성공
        this.userId = checkEmail.checkEmailCode.Admin.ID;
        this.step = 3;
      } else {
        await this.$store.commit("common/snackErrOn", {
          text: "Check code error.",
        });
      }
    },
    async logIn() {
      try {
        this.$router.push({ name: "Login" });
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.email {
  padding-left: 10px;
  font-size: 17px;
  width: 100%;
  height: 50px;
  border: 2px solid #05523e;
}
</style>
